import { A } from '@adornis/base/env-info.js';
import type { Maybe } from '@adornis/base/utilTypes.js';
import { ID } from '@adornis/baseql/baseqlTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import { AdornisEntity } from '@adornis/baseql/entities/adornisEntity.js';

@Entity()
export class LegacyDebitorNumber extends AdornisEntity {
  static override _class = 'LegacyDebitorNumber';

  constructor(doc: Partial<LegacyDebitorNumber>) {
    super(doc);
  }

  @Field(() => ID, { default: v => v ?? A.getGloballyUniqueID() })
  _id!: string;

  /**
   * A legacy debitor number can have a different scope, for example from which legacy system this number originates. In our case this will be schools
   */
  @Field(() => String)
  scope: Maybe<string>;

  /**
   * The actual debitor number from the legacy system. We allow freetext in this field so we do not have any validation here and maximum freedom
   */
  @Field(() => String)
  debitorNumber: Maybe<string>;
}
